import { useContext } from 'react';

import { CheckoutContext } from './CheckoutProvider.context';

const useCheckoutProvider = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('CheckoutProvider not found');
  }
  return context;
};

export { useCheckoutProvider };
